import script from "./PackageTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PackageTable.vue?vue&type=script&setup=true&lang=js"

import "./PackageTable.vue?vue&type=style&index=0&id=43e9b93e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43e9b93e"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QTr,QChip,QTooltip});
